import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DocumentItem } from '@klubovna/shared-models';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { DocumentsApiService } from '../../services/documents.api.service';
import { SentryLoggerService } from '../../services/sentry-logger.service';
import * as DocumentsActions from './documents.actions';

@Injectable()
export class DocumentsEffects {
  private actions$: Actions = inject(Actions);
  private documentsService: DocumentsApiService = inject(DocumentsApiService);
  private sentryLogger: SentryLoggerService = inject(SentryLoggerService);

  loadDocuments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentsActions.loadDocuments),
      mergeMap(() =>
        this.documentsService.getDocuments().pipe(
          map((documents: DocumentItem[]) => DocumentsActions.loadDocumentsSuccess({ documents })),
          catchError((error: unknown) => {
            this.sentryLogger.captureHttpError(error, {
              component: 'DocumentsEffects',
              action: 'loadDocuments',
            });
            return of(DocumentsActions.loadDocumentsFailure({ error: 'Failed to load documents' }));
          }),
        ),
      ),
    ),
  );
}
